import React, {useState} from 'react'
import countryList from 'react-select-country-list'
import { Form, Select, Row, Button, Input, Card, Typography, Spin, notification, Upload ,Avatar} from 'antd'
import { useSelector,useDispatch  } from 'react-redux'
import instance from '../../utils/API'
import { profileActions } from '../../redux/reducers/userProfile'

const { Title } = Typography

const { Option } = Select;
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

const Context = React.createContext({ name: 'Default' });

const UserProfile = ({profile}) => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const countrySelection = countryList().getData()

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);


    const onFinish = (values) => {
        
        setLoading(true);
        if(profile.avatarUrl){
            values.avatarUrl = profile.avatarUrl
            delete values.files
        }
        instance(user.jwt).put("/users/me", values)
            .then(function (response) { 
                dispatch(profileActions.getProfile(user.jwt))
                openSuccessNotif()
                setLoading(false);
            })
            .catch(function (error) {
                setError(true);
                let errorMessage = 'Network Error'
                if (error.response) {
                    errorMessage = error.response.data.message[0].messages[0].message
                    //User does not exist. Sign up for an account
                }
                openErrorNotif(errorMessage)
                setLoading(false);
            })

    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };
  
    const openSuccessNotif = () => {
        notification["success"]({
          message: 'Success',
          description: 'Your profile has been saved.',
          duration: 2
        });
      };

    const openErrorNotif = (msg) => {
        notification["error"]({
        message: 'Error',
        description: msg,
        duration: 2
        });
    };

    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            openErrorNotif('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            openErrorNotif('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
      }

      const handleChange = info => {
        if (info.file.status === 'uploading') {
            setLoading(true);
          return;
        }
        if (info.file.status === 'done') {
            profile.avatarUrl = info.file.response[0].url;
            setLoading(false)
        }
      };
    return (

        <Spin
            size="large"
            spinning={loading}
            delay={100}
        >
        
        <Card
        title={<Title level={5}>Profile</Title>}
        style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
        >
                <Form
                {...layout}
                name="basic"
                initialValues={profile}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                >
                <Form.Item
                    name="files"
                    valuePropName="files"
                    style={{width:'100%', justifyContent:"center"}}
                    wrapperCol={{ span: 16, offset:8 }}

                >
                    <Upload name="files" action={process.env.REACT_APP_BACKEND+"/upload"}
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                        showUploadList={false}
                        className="avatar-uploader"
                        listType="picture-card"
                    >
                    {profile.avatarUrl 
                        ? 
                        <Avatar
                            size={{ xs: 100, sm: 100, md: 100, lg: 100, xl: 100, xxl: 100 }}
                            src={profile.avatarUrl}
                        />
                        : 
                        <Avatar
                            size={{ xs: 100, sm: 100, md: 100, lg: 100, xl: 100, xxl: 100 }}
                        >
                            {profile.firstName.charAt(0) +  profile.lastName.charAt(0) }
                        </Avatar>
                    }
                    </Upload>
                </Form.Item>


                <Form.Item
                label="First Name"
                name="firstName"
                rules={[
                    {
                    required: true,
                    message: "Please enter first name!",
                    type: "string",
                    },
                ]}
                >
                <Input />
                </Form.Item>
        
                <Form.Item
                label="Last Name"
                name="lastName"
                rules={[
                    {
                    required: true,
                    message: "Please enter last name!",
                    type: "string",
                    },
                ]}
                >
                <Input />
                </Form.Item>
        
                <Form.Item
                label="Phone Num."
                name="phoneNumber"
                rules={[
                    {
                    type: "string",
                    },
                ]}
                >
                <Input />
                </Form.Item>
        
                <Form.Item
                label="Country"
                name="country"
                >
                    <Select
                    showSearch
                    placeholder="Select a Country"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    >
                    { countrySelection.map(cntry => (
                        <Option key={cntry.value} value={cntry.label}>{cntry.label}</Option>
                        )) }
                    </Select>
                </Form.Item>
        
                <Row justify="end">
                <Button type="primary" htmlType="submit" style={{width:80}} disabled={loading}>
                    Save
                </Button>
                </Row>
            </Form>
        </Card>
        </Spin>              
    )
}

export default UserProfile
